"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivateAccount = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var styles_1 = __importDefault(require("./styles"));
var Button_1 = require("../../../atoms/Button");
var Text_1 = require("../../../atoms/Text");
var TextField_1 = require("../../../atoms/TextField");
var ActivateAccount = function (_a) {
    var onSubmit = _a.onSubmit, _b = _a.title, title = _b === void 0 ? 'Activate Account' : _b, _c = _a.subtitle, subtitle = _c === void 0 ? 'Please click the link below. We will email you a Verification Code so that you can securely set your password.' : _c, footerText = _a.footerText, error = _a.error, _d = _a.username, username = _d === void 0 ? '' : _d, _e = _a.activateButton, activateButton = _e === void 0 ? 'Request Verification Code' : _e, _f = _a.loading, loading = _f === void 0 ? false : _f;
    var classes = (0, styles_1.default)();
    var _g = (0, react_1.useState)({
        username: username,
    }), state = _g[0], setState = _g[1];
    var _h = (0, react_1.useState)(true), validationError = _h[0], setValidationError = _h[1];
    var validate = (0, react_1.useCallback)(function () {
        var regex = new RegExp(react_common_lib_1.emailRegex);
        var currentUsername = state.username;
        if (!regex.test(currentUsername)) {
            setValidationError(true);
            return;
        }
        setValidationError(false);
    }, [state]);
    (0, react_1.useEffect)(function () {
        validate();
    }, [state, validate]);
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onSubmit(state)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit, className: classes.root }, { children: [(0, jsx_runtime_1.jsxs)("header", __assign({ className: classes.header }, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ "data-testid": "title-text", className: classes.title }, { children: title })), !!subtitle && ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ "data-testid": "subtitle-text", className: classes.subtitle, component: "h2" }, { children: subtitle })))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.field }, { children: (0, jsx_runtime_1.jsx)(TextField_1.TextField, { id: "username", type: "string", label: "Email Address", value: state.username, onChange: function (_a) {
                        var target = _a.target;
                        return setState(__assign(__assign({}, state), { username: target.value }));
                    }, margin: "normal", fullWidth: true, required: true }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.field }, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ "data-testid": "lbl-login-error", className: classes.error }, { children: error || ' ' })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.field }, { children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "activate-account-submit", color: "primary", variant: "contained", "data-testid": "btn-request-code", disabled: validationError, onClick: handleSubmit, fullWidth: true, loading: loading }, { children: activateButton })) })), !!footerText && ((0, jsx_runtime_1.jsx)("footer", __assign({ "data-testid": "footer-text", className: classes.footer }, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, { children: footerText }) })))] })));
};
exports.ActivateAccount = ActivateAccount;
